import { CircularProgress, Grid, Stack, Typography } from "@mui/joy"

function LoadingScreen() {
    return <Grid xs={12}
        sx={{
            textAlign: "center",
            minHeight: "400px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"

        }}>
        <Stack direction={"row"} spacing={2} sx={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        }}>
            <CircularProgress color="danger" />
            <Typography>Carregando dados...</Typography>
        </Stack>
    </Grid>
}

export default LoadingScreen